
  // async urls has been added to help the url parameter validation on the frontend
  // and can be used elsewhere.
export const async_urls = {
  asyncType: 'async_urls',
  hostedScraperType: 'async_urls',
  publicHostedScraperAPIType: 'async_urls',
  inputKey: 'url',
  inputsKey: 'urls',
  inputJsonSchema: {type: 'string'},
  propertiesJsonSchemaPart: {
    autoparse: { type: 'boolean' },
    binary_target: { type: 'boolean' },
    device_type: { type: 'string', 'enum': [ 'desktop', 'mobile'] },
    follow_redirect: { type: 'boolean' },
    premium: { type: 'boolean' },
    render: { type: 'boolean' },
    screenshot: { type: 'boolean' },
    retry_404: { type: 'boolean' },
    ultra_premium: { type: 'boolean' },
    wait_for_selector: { type: 'string' },
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' },
    country_code: { type: 'string' }
  }
};